import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LOCATE_A_JEWELER_LOGO_LARGE } from '@stuller/shared/util/constants'
import { Button } from '@stuller/stullercom/ui'
import { type ReactElement } from 'react'
import { fas } from '@awesome.me/kit-3dbd93c064/icons'

/**
 * Displays information about locating a jeweler whenever the user is not able to add current item to cart
 */
function LocateAJeweler (): ReactElement {
  return (
    <div className='d-flex flex-column border rounded-3 p-5'>
      <div>
        <img src={LOCATE_A_JEWELER_LOGO_LARGE} alt='locate a jeweler' style={{ maxHeight: '50px' }} />
      </div>
      <p className='mt-4'><b>Not a jeweler?</b> Locate a jeweler nearby to purchase the products you see on our website.</p>
      <div className='mt-4'>
        <Button pill outline color='secondary' tag='a' href='/locateajeweler' aria-label='Find nearby jewelers button'>
          <FontAwesomeIcon icon={fas.faMapMarkerAlt} className='me-3' />
          Find Nearby Jewelers
        </Button>
      </div>
    </div>
  )
}

export {
  LocateAJeweler
}
